import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg font-bold font-heading">
                  快
                </span>
                <span className="text-xl font-heading font-bold text-background-50">
                  快猫
                </span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed">
                快猫是备受用户青睐的内容创作与短视频平台，汇聚海量优质创作者与精彩内容。让每一位创作者都能在这里实现梦想。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
              <div className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
                <Link to="/category/platform-news" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">平台动态</Link>
                <Link to="/category/safety-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">安全指南</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2.5 text-sm text-background-300">
                <p>邮箱：contact@kuaimao.com</p>
                <p>合作：partner@kuaimao.com</p>
                <p>客服热线：400-888-6666</p>
                <p>工作时间：周一至周日 9:00-21:00</p>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 快猫平台 版权所有 | 沪ICP备2024000000号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">社区规范</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}